// Bitcoin data through the backend proxy (/v1/rpc/btc/* → mempool.space). The
// client never talks to mempool.space directly — the proxy caches and shields
// the shared rate limit.

import { api } from './api';

export interface ProxyUtxo {
  txid: string;
  vout: number;
  value: number;
  status: { confirmed: boolean };
}

/** UTXOs for an address. Callers must spend CONFIRMED outputs only. */
export async function fetchBtcUtxos(initData: string, address: string): Promise<ProxyUtxo[]> {
  return api<ProxyUtxo[]>(initData, `/v1/rpc/btc/address/${address}/utxo`);
}

/** Fee rate to use for a send, in sat/vB (integer ≥ 1). Uses fastestFee so the
 *  tx confirms in the next block or two — never underprice a payment. */
export async function fetchBtcFeeRate(initData: string): Promise<number> {
  const rates = await api<{ fastestFee: number }>(initData, '/v1/rpc/btc/fees/recommended');
  return Math.max(1, Math.ceil(rates.fastestFee));
}

/** Broadcast a signed raw tx (hex). Returns the txid. */
export async function broadcastBtcTx(initData: string, hexTx: string): Promise<string> {
  const res = await api<{ txid: string }>(initData, '/v1/rpc/btc/tx', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: hexTx,
  });
  return res.txid;
}
